import { render, staticRenderFns } from "./DepositManual.vue?vue&type=template&id=2d71e71c"
import script from "./DepositManual.vue?vue&type=script&lang=js"
export * from "./DepositManual.vue?vue&type=script&lang=js"
import style0 from "./DepositManual.vue?vue&type=style&index=0&id=2d71e71c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports